import { Log } from '@aboutyou/legacy-shared'
import {
  Device,
  Gender,
} from '@aboutyou/legacy-shared/src/grpc_client/grips/protos/shared/shared'
import { getLiveShoppingOverviewPage } from '@aboutyou/legacy-shared/src/pages/Live/LiveShopping.service'
import { Locale } from '@aboutyou/legacy-shared/src/types'
import { getCurrentAppID, getCurrentChildShopID } from 'constants/appIdMappings'
import { FEMALE, KIDS, MALE } from 'constants/gender'
import { isomorphicRedirectTo } from 'helpers/navigation'
import { FetchProps } from 'helpers/redial'
import { GenderType } from 'store/features/user/types'

export const getGripsRequestConfigOptions = ({
  locale,
  gender,
  hostname,
  isSSR,
}: {
  locale: Locale
  gender: Gender
  hostname: string
  isSSR: boolean
}) => {
  return {
    childShopId: getCurrentChildShopID(locale),
    shopId: getCurrentAppID(locale),
    device: Device.DESKTOP,
    isSSR,
    gender,
    hostname,
  }
}

const gendersMap = {
  [FEMALE]: Gender.FEMALE,
  [MALE]: Gender.MALE,
  [KIDS]: Gender.KIDS,
}

const mapToGender = (genderType: GenderType): Gender => {
  return gendersMap[genderType] || Gender.GENDER_INVALID
}

export default {
  fetch: async ({ store, ssr }: FetchProps) => {
    const gender = store.user.gender
    const { locale } = store.localeStore
    const { gripsWebUrl: hostname } = store.urlManager
    const options = getGripsRequestConfigOptions({
      gender: mapToGender(gender),
      locale,
      hostname,
      isSSR: ssr,
    })
    try {
      store.liveShoppingPage.setLoading(true)
      const response = await getLiveShoppingOverviewPage(options)
      store.liveShoppingPage.saveLiveShoppingResponse(gender, response)
      store.liveShoppingPage.setLoading(false)
    } catch (err) {
      Log.error(err)
      store.toastNotifications.addNotification({
        id: 'LIVE_SHOPPING_ERROR',
        duration: 4000,
        message: store.t('Dieses Seite ist leider nicht verfügbar.'),
        type: 'error',
      })
      isomorphicRedirectTo({
        to: `/`,
        urlManager: store.urlManager,
        router: store.router,
      })
    }
  },
}
